//React
import { useState, useEffect } from "react";

//Material UI
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CircularProgress from "../CircleProgress";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

import "./SignUpBox.css";
import { LoginApi } from "../../api";

const SignUpBox = (props) => {
  const [id, setId] = useState(props.userId || "");
  const [name, setName] = useState(props.name || "");
  const [hospitalName, setHospitalName] = useState(props.hospitalName || "");
  const [step, setStep] = useState(props.displayResetPassword ? 1 : 0);
  const [displayResetPassword, setDisplayResetPassword] = useState(props.displayResetPassword || false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [passwordInfo, setPasswordInfo] = useState({
    lowercase: false,
    special: false,
    length: false,
  });

  useEffect(() => {
    if (password) {
      const lowercase = /[a-z]/.test(password);
      const special = /[!@#$%^&*]/.test(password);
      const length = password.length >= 8;

      setPasswordInfo({
        lowercase,
        special,
        length,
      });
    } else {
      setPasswordInfo({
        lowercase: false,
        special: false,
        length: false,
      });
    }
  }, [password]);

  useEffect(() => {
    if (passwordConfirm) {
      const passwordMatch = password === passwordConfirm;
      setPasswordMatch(passwordMatch);
    } else {
      setPasswordMatch(false);
    }
  }, [password, passwordConfirm]);

  const backToLogin = () => {
    props.setLoading(false);
    props.handleNavigate('login');
  };

  // step 변경에 따라 UI 업데이트
  useEffect(() => {
    switch (step) {
      case 1:
        setDisplayResetPassword(true);
        break;
      case 2:
        handleSignUp();
        // step 2 로직 (인증코드 화면)  
        break;
      default:
        if (step >= 2) {
          setStep(2);
        }
        break;
    }
  }, [step]);

  const handleSignUp = async () => {
    props.setLoading(true);
    try {
      if (password.trim() === "") {
        props.setLoading(false);
        alert("비밀번호를 입력해주세요.");
        return;
      }
      if (passwordConfirm.trim() === "") {
        props.setLoading(false);
        alert("비밀번호 확인을 입력해주세요.");
        return;
      }
      const response = await LoginApi.signUp({
        email: id,
        name: name,
        hospitalName: hospitalName,
        password: password,
      });
      if (response.data.statusCode === 200) {
        props.setLoading(false);
        alert("회원가입이 완료되었습니다.");
        window.location.reload();
        return;
      } else {
        props.setLoading(false);
        alert("회원가입에 실패했습니다.");
      }
    } catch (error) {
      props.setLoading(false);
      console.error("SignUp Error ->", error);
    }
  }
  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordShown(!confirmPasswordShown);
  };

  return (
    <div className="signup-box">
      <div className="signup-form">
        <div className="signup-heading-group">
          <div className="signup-heading">Set password</div>
          {displayResetPassword && <div className="signup-subHeading">새로운 비밀번호를 입력해주세요.<br />
            비밀번호는 소문자, 특수기호를 포함해야되며 최소 8자리 이상이어야 합니다.</div>}
        </div>
        {!displayResetPassword && <div className="signup-form-group">
          <div className="login-label">Email</div>
          <input
            className="login-input"
            type="text"
            placeholder="Email을 입력해주세요."
            value={id}
            disabled={true}
            onChange={(e) => setId(e.target.value)}
          />
        </div>}
        {!displayResetPassword && <div className="signup-form-group">
          <div className="login-label">이름</div>
          <input
            className="login-input"
            type="text"
            placeholder="이름을 입력해주세요."
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>}
        {!displayResetPassword && <div className="signup-form-group">
          <div className="login-label">병원 이름</div>
          <input
            className="login-input"
            type="text"
            placeholder="병원 이름을 입력해주세요."
            value={hospitalName}
            onChange={(e) => setHospitalName(e.target.value)}
          />
        </div>}
        {displayResetPassword &&
          <div>
            <div className="signup-password-info">
              <div style={{ color: !passwordInfo.lowercase ? "var(--color-danger)" : "var(--color-bg-dark)" }}>{!passwordInfo.lowercase ? <CloseIcon className="CloseIcon" sx={{ fontSize: 20 }}
              /> : <CheckIcon className="CheckIcon" sx={{ fontSize: 20 }} />}소문자 포함</div>
              <div style={{ color: !passwordInfo.special ? "var(--color-danger)" : "var(--color-bg-dark)" }}>{!passwordInfo.special ? <CloseIcon className="CloseIcon" sx={{ fontSize: 20 }}
              /> : <CheckIcon className="CheckIcon" sx={{ fontSize: 20 }} />}특수기호 포함</div>
              <div style={{ color: !passwordInfo.length ? "var(--color-danger)" : "var(--color-bg-dark)" }}>{!passwordInfo.length ? <CloseIcon className="CloseIcon" sx={{ fontSize: 20 }}
              /> : <CheckIcon className="CheckIcon" sx={{ fontSize: 20 }} />}8자리 이상</div>
            </div>
            <div className="signup-form-group">
              <div className="login-label">새로운 비밀번호</div>
              <div className="signup-wrapper">
                <input
                  className="login-input"
                  type={passwordShown ? "text" : "password"}
                  placeholder="새로운 비밀번호를 입력해주세요."
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={props.loading}
                />
                <button
                  className="signup-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {passwordShown ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
            </div>
            <div className="gap"></div>
            <div className="signup-form-group"
              style={{ marginBottom: "30px" }}
            >
              <div className="login-label">새로운 비밀번호 확인</div>
              <div className="signup-wrapper">

                <input
                  style={{
                    border: passwordConfirm.length > 0
                      ? (passwordMatch ? "1px solid #cecece" : "1px solid var(--color-danger)")
                      : undefined
                  }}
                  className="login-input"
                  type={confirmPasswordShown ? "text" : "password"}
                  placeholder="새로운 비밀번호를 입력해주세요."
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  disabled={props.loading}
                />
                <button
                  className="signup-toggle"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {confirmPasswordShown ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
            </div>
          </div>
        }
      </div>
      <div className="change-password-modal-button-container"
      >
        <button
          className={`back-button`}
          type="button"
          onClick={backToLogin}
        >
          취소
        </button>
        <button
          className={`change-password-modal-next-button ${
            props.loading ||
            !id ||
            (step === 0 && (!name?.trim() || !hospitalName?.trim())) ||
            (step === 1 &&
              (!passwordInfo.lowercase ||
                !passwordInfo.special ||
                !passwordInfo.length ||
                !passwordMatch))
              ? "loading"
              : ""
          }`}
          type="button"
          onClick={() => setStep(prev => prev + 1)}
          disabled={
            props.loading ||
            !id ||
            (step === 0 && (!name?.trim() || !hospitalName?.trim())) ||
            (step === 1 &&
              (!passwordInfo.lowercase ||
                !passwordInfo.special ||
                !passwordInfo.length ||
                !passwordMatch))
          }
        >
          {!props.loading ? (
            "다음"
          ) : (
            <CircularProgress color="white" thickness={4} size={19} />
          )}
        </button>
      </div>
    </div>
  );
};

export default SignUpBox;
